/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { GlobalStyle } from 'styles/global-styles';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { LoginPage } from './pages/LoginPage';
import { RegistrationPage } from './pages/RegistrationPage';
import { TryitRegistrationPage } from './pages/TryitRegistrationPage';
import { NonCompetingMembershipPage } from './pages/NonCompetingMembershipPage';
import { AssociateMembershipPage } from './pages/AssociateMembershipPage';
import RiderRegistrationLayout from './Layouts/RiderRegistrationLayout';
import ReturningRider from './pages/RiderRegistrationPage/components/ReturningRider';
import TermsandConditons from './components/TermsandConditions';
import RiderRegistrationPlacementLayout from './Layouts/RiderRegistrationPlacementLayout';
import TryitRiderRegistrationLayout from './Layouts/TryitRiderRegistrationLayout';
import ReturningMember from './pages/TryitRiderRegistrationPage/components/ReturningMember';
import TryitRiderInformation from './pages/TryitRiderRegistrationPage/components/ReturningMember/components/TryitRiderInformation';
import NewMember from './pages/TryitRiderRegistrationPage/components/NewMember';
import TryitRiderRegistrationPage from './pages/TryitRiderRegistrationPage';
import RiderRegistrationPage from './pages/RiderRegistrationPage';
import TryitRiderRegistrationPlacementLayout from './Layouts/TryitRiderRegistrationPlacementLayout';
import TryitMembershipForm from './pages/TryitRiderRegistrationPage/components/ReturningMember/components/TryitRiderInformation/components/TryitMembershipForm';
import TryitRiderRegistrationPlacementPaymentLayout from './Layouts/TryitRiderRegistrationPlacementPaymentlayout';
import EWDMembershipFormLayout from './Layouts/EWDMembershipFormLayout';
import EWDReturningMember from './pages/EWDMembershipFormPage/component/ReturningMember';
import EWDNewMember from './pages/EWDMembershipFormPage/component/NewMember';
import EWDMembershipEligibilityLayout from './Layouts/EWDMembershipEligilityLayout';
import EWDMembershipEquipmentLayout from './Layouts/EWDMembershipEquipmentLayout';
import AlumniLayout from './Layouts/AlumniLayout';
import AlumniNewMemberResgistration from './pages/AlumniRegistrationPage/components/AlumniNewMemberResgistration';
import TryitEWDMembershipLayout from './Layouts/TryitEWDMembershipLayout';
import TryitEWDMembershipPage from './pages/TryitEWDMembershipPage';
import TryitEWDReturningMember from './pages/TryitEWDMembershipPage/component/ReturningMember';
import TryitEWDRiderInformation from './pages/TryitEWDMembershipPage/component/ReturningMember/components/TryitEWDRiderInformation';
import TryitEWDMembershipEligibilityLayout from './Layouts/TryitEWDMembershipEligilityLayout';
import { TryitEligibilityDetailsReturning } from './pages/TryitEWDMembershipPage/component/ReturningMember/components/TryitEWDRiderInformation/components/ElgibilityDetails';
import TryitEligibilityConditionsReturning from './pages/TryitEWDMembershipPage/component/ReturningMember/components/TryitEWDRiderInformation/components/ElgibilityConditions';
import TryitEWDMembershipEquipmentLayout from './Layouts/TryitEWDMembershipEquipmentLayout';
import { TryitEquipmentDetailsReturning } from './pages/TryitEWDMembershipPage/component/ReturningMember/components/TryitEWDRiderInformation/components/EquimentDetails';
import TryitAdaptiveEquipmentsReturning from './pages/TryitEWDMembershipPage/component/ReturningMember/components/TryitEWDRiderInformation/components/AdaptiveEquipments';
import TryitEWDNewMember from './pages/TryitEWDMembershipPage/component/NewMember';
import AlumniReturningMemberRegistration from './pages/AlumniRegistrationPage/components/AlumniReturningMemberRegistration';
import AlumniTryItLayout from './Layouts/AlumniTryItLayout';
import AlumniTryItResgistration from './pages/AlumniRegistrationPage/components/AlumniTryItResgistration';
import RiderLandingPage from './pages/RiderLandingPage';
import SIF from './pages/RiderLandingPage/components/SIF';
import EwdNewEnrollment from './pages/RiderLandingPage/components/SIF/component/EwdNewEnrollment';
import EwdSustainingEnrollment from './pages/RiderLandingPage/components/SIF/component/EwdSustainingEnrollment';
import RiderSustainingEnrollment from './pages/RiderLandingPage/components/SIF/component/RiderSustainingEnrollment';
import RiderNewEnrollment from './pages/RiderLandingPage/components/SIF/component/RiderNewEnrollment';
import CoachRegistrationLayout from './Layouts/CoachRegistrationLayout';
import CoachResgistration from './pages/CoachRegistrationPage/components/CoachResgistration';
import CoachInsurance from './pages/CoachRegistrationPage/components/CoachInsurance';
import ApplyingForCoachResgistration from './pages/CoachRegistrationPage/components/ApplyingForCoachResgistration';
import AssistantCoachResgistration from './pages/CoachRegistrationPage/components/AssistantCoachResgistration';
import CoachTryItLayout from './Layouts/CoachTryItLayout';
import CoachTryItResgistration from './pages/CoachRegistrationPage/components/CoachTryItResgistration';
import NotReturningRider from './pages/RiderRegistrationPage/components/NotReturningRider';
import Dashboard from './pages/RiderLandingPage/components/Dashboard';
import ShowPoints from './pages/RiderLandingPage/components/ShowPoints';
import PaymentPage from './pages/PaymentPage';
import NonCompetingLayout from './Layouts/NonCompetingLayout';
import NonCompetingReturningRider from './pages/NonCompetingMembershipPage/components/NonCompetingReturningMember';
import { CoachLogin } from './pages/CoachLogin';
import CoachDashBoard from './pages/RiderLandingPage/components/CoachLogin/Index';
import CoachLandingPage from './pages/CoachLandingPage/Index';
import CoachInsuranceApplication from './pages/CoachLandingPage/Components/InsuranceApplication/Index';
import PasswordResetEmail from './components/PasswordResetEmail';
import AdminPanelPage from './pages/AdminPanel';
import { Components } from './pages';
import {
  TeamsPage,
  TeamIndividual,
  RiderCreateViewPage,
  RiderIndividual,
} from 'admin/pages';
import { MHToast } from './components/MHToast';
import AdminLayout from './Layouts/AdminLayout';
import RidersPage from 'admin/pages/RidersPage';
import CoachesPage from 'admin/pages/CoachesPage';
import UserPage from 'admin/pages/UserPage';
import { UserIndividual } from 'admin/pages/UserIndividual';
import { UserCreateEditPage } from 'admin/pages/UserIndividual/Components/UserCreateEditPage/components';
import { CoachIndividualPage } from 'admin/pages/CoachIndividualPage';
import { CoachCreateEditPage } from 'admin/pages/CoachIndividualPage/components/coachCreateEditPage';
import CurrentSeasonPage from 'admin/pages/ShowsPage/CurrentSeasonPage';
import { ShowIndividual } from 'admin/pages/ShowIndividual';
import ProtectedRoute, { ProtectedRouteProps } from './ProtectedRoute';
import Cookies from 'js-cookie';
import { ShowCreateEditPage } from 'admin/pages/ShowIndividual/Components/ShowCreateEditPage';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsAccessToken } from './pages/slice/selectors';
import { useManagePageSlice } from './pages/slice';
import { CreateShowsRider } from 'admin/pages/ShowIndividual/Components/ShowManageRider/CreateShowsRider';
import PastTeamList from 'admin/pages/PastDataPage';
import PastCoachList from 'admin/pages/PastDataPage/PastCoachList';
import PastRiderList from 'admin/pages/PastDataPage/PastRiderList';
import SponsersPage from 'admin/pages/SponsersPage';
import ShowResultPage from 'admin/pages/ShowsPage/ShowResultPage';
import SettingsPage from 'admin/pages/SettingsPage';
import SeasonSettings from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/seasonSettings';
import ProfileSettingsPage from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/ProfileSettingPage';
import { ProfileUpdatePage } from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/ProfileUpdatePage';
import RiderPointsReportsTable from 'admin/pages/ReportsPage/RiderPointsReportsTable';
import TeamPointsReportsTable from 'admin/pages/ReportsPage/TeamPointsReportsTable';
import { TeamRoster } from 'admin/pages/ReportsPage/TeamRoster';
import { SIFReports } from 'admin/pages/SIFReportPage';
import { ShowRiderReportGroups } from 'admin/pages/ReportsPage/ShowRiderReportGroups';
import { ShowGenerateSplitPage } from 'admin/pages/ShowGenerateSplitPage';
import Roles from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/Roles';
import { usePermissionSlice } from 'store/permission/slice';
import { usePermissionOperations } from 'hooks/usePermissionsOperation';
import SponserCreateViewPage from 'admin/pages/SponsersPage/sponserCreateViewPage';
import { ShowDetailsPage } from 'admin/pages/ShowDetailsPage';
import DashboardPage from 'admin/pages/DashboardPage';
import BackNumberManagement from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/BackNumberManagement/BackNumberManagement';
import FeeManagementPage from 'admin/pages/SettingsPage/SettingsCard/Components/SettingsPages/FeeManagementPage/FeeManagementPage';
import { FinancialReport } from 'admin/pages/FinancialReportsPage';
import RegistrationReportPage from 'admin/pages/RegistrationPage';
import LiveRankingPage from './pages/LiveRankingPage';
import InnerViewTeams from './pages/LiveRankingPage/InnerViewTeams';
import ImageManagement from 'admin/pages/ImageManagement';
import ApproveRiderPage from 'admin/pages/ApproveRiderPage';
import DocumentImageManagement from 'admin/pages/DocumentImageImageManagement';
import CoachInsuranceReport from 'admin/pages/CoachInsuranceReportPage';

window.addEventListener('popstate', () => {
  if (!window.location.pathname.includes('/payment/')) {
    const iframe = document.querySelector('[title="INTERMEDIATE"]');
    const cloverFooter = document.querySelector('.clover-footer');
    const cloverScriptWrapper = document.querySelector('scriptWrapper');

    if (cloverScriptWrapper) cloverScriptWrapper.remove();

    if (cloverFooter) cloverFooter.remove();

    if (iframe) {
      const parentDiv = iframe.parentElement;

      if (parentDiv) parentDiv.remove();
    }
  }
});

// Component to watch pathname and update background color based on route
function PathWatcher() {
  const location = useLocation();

  React.useEffect(() => {
    if (
      location.pathname.includes('/admin') ||
      location.pathname.includes('/coach')
    ) {
      // Admin/Coach pages - white background
      document.body.style.backgroundColor = '#ffffff';
    } else {
      // User pages - dark background
      document.body.style.backgroundColor = '#2a2a2a';
    }
  }, [location.pathname]);

  return null;
}

export function App() {
  const dispatch = useDispatch();
  const { actions: PageActions } = useManagePageSlice();
  const IsAccessToken = useSelector(selectIsAccessToken);
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, 'outlet'> = {
    isAuthenticated: isAuthenicated(),
    authenticationPath: '/',
  };
  function isAuthenicated(): boolean {
    const accessToken = Cookies.get('accessToken');
    if (accessToken) {
      dispatch(PageActions.setIsAccessToken(accessToken ?? undefined));
      return true;
    } else {
      return false;
    }
  }
  usePermissionSlice();

  const { fetchPermissions } = usePermissionOperations();

  // Function to fetch all user permissions
  async function getAllUserPermissions() {
    try {
      await fetchPermissions();
    } catch (err) {
      console.error(err);
    }
  }

  React.useEffect(() => {
    if (isAuthenicated()) {
      getAllUserPermissions();
    }
  }, [IsAccessToken]);
  return (
    <BrowserRouter>
      <PathWatcher />
      <Routes>
        <Route path="/login/:action?" element={<LoginPage />} />
        <Route path="/coach-login" element={<CoachLogin />} />
        <Route path="/" element={<LoginPage />} />
        <Route path="/reset-password" element={<PasswordResetEmail />} />
        <Route path="*" element={<NotFoundPage />} />
        <Route path="/registration" element={<RegistrationPage />} />
        <Route
          path="/payment/:payerType/:payerId/:isSif/:isSifSustain"
          element={<PaymentPage />}
        />
        <Route path="/team-ranking" element={<LiveRankingPage />} />
        <Route path="/team-ranking/:id" element={<InnerViewTeams />} />
        {/* Admin Section Start */}
        <Route element={<AdminLayout />}>
          <Route
            path="/components"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/components',
                }}
                outlet={<Components />}
              />
            }
          />
          <Route
            path="/admin/registration-report"
            element={
              <ProtectedRoute
                permissionId="11"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/registration-report',
                }}
                outlet={<RegistrationReportPage />}
              />
            }
          />
          <Route
            path="/admin/coach-insurance-report"
            element={
              <ProtectedRoute
                permissionId="12"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/coach-insurance-report',
                }}
                outlet={<CoachInsuranceReport />}
              />
            }
          />
          {/* Team Admin Section */}
          <Route
            path="/admin/teams/:status?"
            element={
              <ProtectedRoute
                permissionId="02"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/teams',
                }}
                outlet={<TeamsPage />}
              />
            }
          />
          <Route
            path="/coach/teams/:status?"
            element={
              <ProtectedRoute
                permissionId="02"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/teams',
                }}
                outlet={<TeamsPage />}
              />
            }
          />
          <Route
            path="/admin/teams/:action/:tab/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/teams',
                }}
                outlet={<TeamIndividual />}
              />
            }
          />
          <Route
            path="/coach/teams/:action/:tab/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/teams',
                }}
                outlet={<TeamIndividual />}
              />
            }
          />
          {/* Rider Admin Section */}
          <Route
            path="/admin/riders/:status?"
            element={
              <ProtectedRoute
                permissionId="03"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/riders',
                }}
                outlet={<RidersPage />}
              />
            }
          />
          <Route
            path="/coach/riders/:status?"
            element={
              <ProtectedRoute
                permissionId="03"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/riders',
                }}
                outlet={<RidersPage />}
              />
            }
          />
          <Route
            path="/admin/riders/add/:action"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/riders',
                }}
                outlet={<RiderCreateViewPage />}
              />
            }
          />
          <Route
            path="/coach/riders/add/:action"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/riders',
                }}
                outlet={<RiderCreateViewPage />}
              />
            }
          />
          <Route
            path="/admin/riders/:action/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/riders',
                }}
                outlet={<RiderCreateViewPage />}
              />
            }
          />
          <Route
            path="/coach/riders/:action/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/riders',
                }}
                outlet={<RiderCreateViewPage />}
              />
            }
          />
          <Route
            path="/admin/riders/view/:tab/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/riders',
                }}
                outlet={<RiderIndividual />}
              />
            }
          />
          <Route
            path="/coach/riders/view/:tab/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/riders',
                }}
                outlet={<RiderIndividual />}
              />
            }
          />
          {/* Coaches Admin Section */}
          <Route
            path="/admin/coaches/:status?"
            element={
              <ProtectedRoute
                permissionId="04"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/coaches',
                }}
                outlet={<CoachesPage />}
              />
            }
          />
          <Route
            path="/admin/coaches/view/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/coaches',
                }}
                outlet={<CoachIndividualPage />}
              />
            }
          />
          <Route
            path="/admin/coaches/add/:action/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/coaches',
                }}
                outlet={<CoachCreateEditPage />}
              />
            }
          />
          {/* User Admin Section */}
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute
                permissionId="01"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/users',
                }}
                outlet={<UserPage />}
              />
            }
          />
          <Route
            path="/admin/users/view/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/users',
                }}
                outlet={<UserIndividual />}
              />
            }
          />
          <Route
            path="/admin/users/:action/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/users',
                }}
                outlet={<UserCreateEditPage />}
              />
            }
          />
          {/* Show Admin Section */}
          <Route
            path="/admin/shows/:status?"
            element={
              <ProtectedRoute
                permissionId="05"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows',
                }}
                outlet={<CurrentSeasonPage />}
              />
            }
          />
          <Route
            path="/coach/shows/:status?"
            element={
              <ProtectedRoute
                permissionId="05"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows',
                }}
                outlet={<CurrentSeasonPage />}
              />
            }
          />
          <Route
            path="/admin/shows/create"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows/create',
                }}
                outlet={<ShowCreateEditPage />}
              />
            }
          />
          <Route
            path="/coach/shows/create"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows/create',
                }}
                outlet={<ShowCreateEditPage />}
              />
            }
          />
          <Route
            path="/admin/shows/duplicate"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows/duplicate',
                }}
                outlet={<ShowCreateEditPage />}
              />
            }
          />
          <Route
            path="/coach/shows/duplicate"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows/duplicate',
                }}
                outlet={<ShowCreateEditPage />}
              />
            }
          />
          <Route
            path="/admin/shows/:action/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows',
                }}
                outlet={<ShowCreateEditPage />}
              />
            }
          />
          <Route
            path="/coach/shows/edit/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows/edit',
                }}
                outlet={<ShowCreateEditPage />}
              />
            }
          />
          <Route
            path="/admin/shows/view/:id/:tab"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows',
                }}
                outlet={<ShowIndividual />}
              />
            }
          />
          <Route
            path="/coach/shows/view/:id/:tab"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows',
                }}
                outlet={<ShowIndividual />}
              />
            }
          />
          <Route
            path="/admin/shows/show-result/:tab/:id/:showName?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows',
                }}
                outlet={<ShowResultPage />}
              />
            }
          />
          <Route
            path="/coach/shows/show-result/:tab/:id/:showName?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows',
                }}
                outlet={<ShowResultPage />}
              />
            }
          />
          <Route
            path="/admin/shows/generate-split/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows',
                }}
                outlet={<ShowGenerateSplitPage />}
              />
            }
          />
          <Route
            path="/coach/shows/generate-split/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows',
                }}
                outlet={<ShowGenerateSplitPage />}
              />
            }
          />
          {/* approve pending rider Section for coach */}
          <Route
            path="/coach/pending-riders"
            element={
              <ProtectedRoute
                permissionId="05"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/pending-riders',
                }}
                outlet={<ApproveRiderPage />}
              />
            }
          />
          {/* past data Admin Section */}
          <Route
            path="/admin/past-data/teams/:status?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/teams',
                }}
                outlet={<PastTeamList />}
              />
            }
          />
          <Route
            path="/admin/past-data/teams/:action/:tab/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/teams',
                }}
                outlet={<TeamIndividual />}
              />
            }
          />
          {/* Show Past Data */}
          <Route
            path="/admin/past-data/shows/:status?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/shows',
                }}
                outlet={<CurrentSeasonPage />}
              />
            }
          />
          <Route
            path="/admin/past-data/shows/view/:tab/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/shows',
                }}
                outlet={<ShowIndividual />}
              />
            }
          />{' '}
          <Route
            path="/admin/shows/view/:id/:tab/:action/:showName?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/shows',
                }}
                outlet={<CreateShowsRider />}
              />
            }
          />
          <Route
            path="/coach/shows/view/:id/:tab/:action/:showName?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/shows',
                }}
                outlet={<CreateShowsRider />}
              />
            }
          />
          <Route
            path="/admin/past-data/coaches/:status?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/coaches',
                }}
                outlet={<PastCoachList />}
              />
            }
          />
          <Route
            path="/admin/past-data/coaches/view/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/coaches',
                }}
                outlet={<CoachIndividualPage />}
              />
            }
          />
          <Route
            path="/admin/past-data/riders/:status?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/riders',
                }}
                outlet={<PastRiderList />}
              />
            }
          />
          <Route
            path="/admin/past-data/riders/view/:tab/:id"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/past-data/riders',
                }}
                outlet={<RiderIndividual />}
              />
            }
          />
          {/* Admin Sponser Section*/}
          <Route
            path="/admin/sponsors"
            element={
              <ProtectedRoute
                permissionId="08"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/sponsors',
                }}
                outlet={<SponsersPage />}
              />
            }
          />
          <Route
            path="/admin/sponsors/:action/:id?"
            element={
              <ProtectedRoute
                permissionId="08"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/sponsors',
                }}
                outlet={<SponserCreateViewPage />}
              />
            }
          />
          {/* Admin Settings Section*/}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/dashboard',
                }}
                outlet={<DashboardPage />}
              />
            }
          />
          <Route
            path="/coach/dashboard"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/coach/dashboard',
                }}
                outlet={<DashboardPage />}
              />
            }
          />
          <Route
            path="/admin/settings"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<SettingsPage />}
              />
            }
          />
          <Route
            path="/admin/settings/seasonSettings"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<SeasonSettings />}
              />
            }
          />
          <Route
            path="/admin/settings/profile-settings"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<ProfileSettingsPage />}
              />
            }
          />
          <Route
            path="/admin/settings/profile-settings/edit"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<ProfileUpdatePage />}
              />
            }
          />
          <Route
            path="/admin/settings/roles/:action?/:id?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<Roles />}
              />
            }
          />
          <Route
            path="/admin/settings/back-number-management"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<BackNumberManagement />}
              />
            }
          />
          <Route
            path="/admin/settings/fee-management"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings',
                }}
                outlet={<FeeManagementPage />}
              />
            }
          />
          <Route
            path="/admin/settings/image-management"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings/image-management',
                }}
                outlet={<ImageManagement />}
              />
            }
          />
          <Route
            path="/admin/settings/document-image-management"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/settings/document-image-management',
                }}
                outlet={<DocumentImageManagement />}
              />
            }
          />
          {/* Admin Finanical Report Page */}
          <Route
            path="/admin/financial-report"
            element={
              <ProtectedRoute
                permissionId="10"
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/financial-report',
                }}
                outlet={<FinancialReport />}
              />
            }
          />
          {/* Admin Reports Page */}
          <Route
            path="/admin/reports/rider-points"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/reports/rider-points',
                }}
                outlet={<RiderPointsReportsTable />}
              />
            }
          />
          <Route
            path="/admin/reports/team-points"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/reports/team-points',
                }}
                outlet={<TeamPointsReportsTable />}
              />
            }
          />
          <Route
            path="/admin/reports/sif-report"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/reports/sif-report',
                }}
                outlet={<SIFReports />}
              />
            }
          />
          <Route
            path="/admin/reports/team-roster"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/reports/team-roster',
                }}
                outlet={<TeamRoster />}
              />
            }
          />
          <Route
            path="/admin/reports/show-details/:showid?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/reports/show-details',
                }}
                outlet={<ShowDetailsPage />}
              />
            }
          />
          <Route
            path="/admin/reports/show-rider-report-groups/:showid?"
            element={
              <ProtectedRoute
                {...{
                  ...defaultProtectedRouteProps,
                  redirectPath: '/admin/reports/show-rider-report-groups',
                }}
                outlet={<ShowRiderReportGroups />}
              />
            }
          />
        </Route>
        {/* Admin Section End */}
        <Route
          path="/try-it-registration"
          element={<TryitRegistrationPage />}
        />
        <Route element={<NonCompetingLayout />}>
          {/* <Route
            path="/non-competing-membership"
            element={<NonCompetingRegistration />}
          /> */}
          <Route
            path="/non-competing-membership/returning-member"
            element={<NonCompetingReturningRider />}
          />
        </Route>
        <Route element={<AdminPanelPage />} path="/admin-panel" />
        <Route
          path="/non-competing-membership/new-member"
          element={<NonCompetingMembershipPage />}
        />
        <Route
          path="/associate-membership"
          element={<AssociateMembershipPage />}
        />
        {/* Coach login */}
        <Route element={<CoachLandingPage />}>
          <Route
            path="/rider-landing-page/coach-dashboard"
            element={<CoachDashBoard />}
          />
          <Route
            path="/rider-landing-page/coach-insurance-application"
            element={<CoachInsuranceApplication />}
          />
        </Route>
        {/* Rider Landing Page */}
        <Route element={<RiderLandingPage />}>
          <Route path="/rider-landing-page/dashboard" element={<Dashboard />} />
          <Route
            path="/rider-landing-page/show-points"
            element={<ShowPoints />}
          />

          <Route path="/rider-landing-page/sif" element={<SIF />} />
          <Route
            path="/rider-landing-page/sif/ewd-new-enrollment"
            element={<EwdNewEnrollment />}
          />
          <Route
            path="/rider-landing-page/sif/ewd-sustaining-enrollment"
            element={<EwdSustainingEnrollment />}
          />
          <Route
            path="/rider-landing-page/sif/rider-new-enrollment"
            element={<RiderNewEnrollment />}
          />
          <Route
            path="/rider-landing-page/sif/rider-sustaining-enrollment"
            element={<RiderSustainingEnrollment />}
          />
        </Route>

        {/* Rider Registration page route */}
        <Route element={<RiderRegistrationLayout />}>
          <Route
            path="/rider-registration-page"
            element={<RiderRegistrationPage />}
          />
          <Route
            path="/rider-registration-page/returning-rider"
            element={<ReturningRider />}
          />
          {/* <Route
            path="/rider-registration-page/returning-rider/details"
            element={<RiderInformation />}
          /> */}

          <Route
            path="/rider-registration-page/terms-and-conditions"
            element={<TermsandConditons />}
          />
          <Route
            path="/rider-registration-page/new-rider"
            element={<NotReturningRider />}
          />
          {/* <Route
            path="/rider-registration-page/new-rider/personal-info"
            element={<PersonalInfo />}
          /> */}
        </Route>

        <Route element={<RiderRegistrationPlacementLayout />}>
          {/* <Route
            path="/rider-registration-page/returning-rider/individual-placement"
            element={<IndividualPlacementForm />}
          /> */}
          {/* <Route
            path="/rider-registration-page/new-rider/individual-placement"
            element={<IndividualPlacementFormNewRider />}
          /> */}
          {/* <Route
            path="/rider-registration-page/returning-rider/individual-placement-payment"
            element={<IndividualPlacementFormTwo />}
          /> */}
          {/* <Route
            path="/rider-registration-page/new-rider/individual-placement-payment"
            element={<IndividualPlacementFormTwoNewRider />}
          /> */}
        </Route>

        {/* Try it Rider Registration page route */}
        <Route element={<TryitRiderRegistrationLayout />}>
          <Route
            path="/tryit-rider-registration-page"
            element={<TryitRiderRegistrationPage />}
          />
          <Route
            path="/tryit-rider-registration-page/returning-member"
            element={<ReturningMember />}
          />
          <Route
            path="/tryit-rider-registration-page/returning-member/details"
            element={<TryitRiderInformation />}
          />
          <Route
            path="/tryit-rider-registration-page/returning-member/membership-placement"
            element={<TryitMembershipForm />}
          />
          <Route
            path="/tryit-rider-registration-page/terms-and-conditions"
            element={<TermsandConditons />}
          />
          <Route
            path="/tryit-rider-registration-page/new-member"
            element={<NewMember />}
          />
          {/* <Route
            path="/tryit-rider-registration-page/new-member/membership-form"
            element={<NewMemberMembershipForm />}
          /> */}
          {/* <Route
            path="/tryit-rider-registration-page/new-member/personal-info"
            element={<NewMemberPersonalInfo />}
          /> */}
        </Route>

        <Route element={<TryitRiderRegistrationPlacementLayout />}>
          {/* <Route
            path="/tryit-rider-registration-page/returning-member/tryit-individual-placement"
            element={<TryitIndividualPlacementForm />}
          /> */}
        </Route>

        <Route element={<TryitRiderRegistrationPlacementPaymentLayout />}>
          {/* <Route
            path="/tryit-rider-registration-page/returning-member/tryit-individual-placement-payment"
            element={<IndividualPlacementFormTwo />}
          /> */}
          {/* <Route
            path="/tryit-rider-registration-page/new-member/individual-placement-payment"
            element={<NewMemberIndividualPlacementFormTwoNewRider />}
          /> */}
        </Route>

        {/* EWD Membership form page route */}
        <Route element={<EWDMembershipFormLayout />}>
          {/* <Route
            path="/ewd-membership-form"
            element={<EWDMembershipFormPage />}
          /> */}
          <Route
            path="/ewd-membership-form/returning-member"
            element={<EWDReturningMember />}
          />
          <Route
            path="/ewd-membership-form/new-member"
            element={<EWDNewMember />}
          />
        </Route>
        <Route element={<EWDMembershipEligibilityLayout />}>
          {/* <Route
            path="/ewd-membership-form/returning-member/eligibile-details"
            element={<EligibilityDetailsReturning />}
          /> */}
          {/* <Route
            path="/ewd-membership-form/returning-member/eligibile-conditions"
            element={<EligibilityConditionsReturning />}
          /> */}
          {/* <Route
            path="/ewd-membership-form/new-member/eligibile-details"
            element={<EligibilityDetailsNew />}
          />
          <Route
            path="/ewd-membership-form/new-member/eligibile-conditions"
            element={<EligibilityConditionsNew />}
          /> */}
        </Route>
        <Route element={<EWDMembershipEquipmentLayout />}>
          {/* <Route
            path="/ewd-membership-form/returning-member/equipment-details"
            element={<EquipmentDetailsReturning />}
          /> */}
          {/* <Route
            path="/ewd-membership-form/returning-member/adaptive-equipments"
            element={<AdaptiveEquipmentsReturning />}
          /> */}
          {/* <Route
            path="/ewd-membership-form/new-member/equipment-details"
            element={<EquipmentDetailsNew />}
          />
          <Route
            path="/ewd-membership-form/new-member/adaptive-equipments"
            element={<AdaptiveEquipmentsNew />}
          /> */}
        </Route>

        {/* Try it EWD Membership form page route */}
        <Route element={<TryitEWDMembershipLayout />}>
          <Route
            path="/tryit-ewd-membership-form"
            element={<TryitEWDMembershipPage />}
          />
          <Route
            path="/tryit-ewd-membership-form/returning-member"
            element={<TryitEWDReturningMember />}
          />
          <Route
            path="/tryit-ewd-membership-form/returning-member/details"
            element={<TryitEWDRiderInformation />}
          />

          <Route
            path="/tryit-ewd-membership-form/new-member"
            element={<TryitEWDNewMember />}
          />
        </Route>

        <Route element={<TryitEWDMembershipEligibilityLayout />}>
          <Route
            path="/tryit-ewd-membership-form/returning-member/eligibile-details"
            element={<TryitEligibilityDetailsReturning />}
          />
          <Route
            path="/tryit-ewd-membership-form/returning-member/eligibile-conditions"
            element={<TryitEligibilityConditionsReturning />}
          />
          {/* <Route
            path="/tryit-ewd-membership-form/new-member/eligibile-details"
            element={<TryitEligibilityDetailsNew />}
          />
          <Route
            path="/tryit-ewd-membership-form/new-member/eligibile-conditions"
            element={<TryitEligibilityConditionsNew />}
          /> */}
        </Route>

        <Route element={<TryitEWDMembershipEquipmentLayout />}>
          <Route
            path="/tryit-ewd-membership-form/returning-member/equipment-details"
            element={<TryitEquipmentDetailsReturning />}
          />
          <Route
            path="/tryit-ewd-membership-form/returning-member/adaptive-equipments"
            element={<TryitAdaptiveEquipmentsReturning />}
          />
          {/* <Route
            path="/tryit-ewd-membership-form/new-member/equipment-details"
            element={<TryitEquipmentDetailsNew />}
          />
          <Route
            path="/tryit-ewd-membership-form/new-member/adaptive-equipments"
            element={<TryitAdaptiveEquipmentsNew />}
          /> */}
        </Route>
        <Route element={<AlumniLayout />}>
          {/* <Route path="/alumni-registration" element={<AlumniRegistration />} /> */}
          <Route
            path="/alumni-registration/new-member"
            element={<AlumniNewMemberResgistration />}
          />
          <Route
            path="/alumni-registration/returning-member"
            element={<AlumniReturningMemberRegistration />}
          />
        </Route>
        <Route element={<AlumniTryItLayout />}>
          <Route
            path="/alumni-try-it-registration"
            element={<AlumniTryItResgistration />}
          />
        </Route>
        {/* <Route path="/coach-registration" element={<CoachRegistrationPage />} /> */}
        <Route element={<CoachRegistrationLayout />}>
          <Route
            path="/coach-registration"
            element={<ApplyingForCoachResgistration />}
          />
          <Route
            path="/coach-registration/coach"
            element={<CoachResgistration />}
          />
          <Route
            path="/coach-registration/coach-insurance"
            element={<CoachInsurance />}
            caseSensitive={true}
          />
          <Route
            path="/coach-registration/assistant-coach"
            element={<AssistantCoachResgistration />}
          />
        </Route>
        <Route element={<CoachTryItLayout />}>
          <Route
            path="/coach-registration/try-it"
            element={<CoachTryItResgistration />}
          />
        </Route>
      </Routes>
      <GlobalStyle />
      {/* <ToastContainer /> */}
      <MHToast />
    </BrowserRouter>
  );
}
